import Header from './header'
import SecondHeader from './second'
import Link from './link'
import Title from './title'
import SimpleHeader from './simple-header'

const HeaderLink = Link
const HeaderTitle = Title

export {
  Header,
  SecondHeader,
  HeaderLink,
  HeaderTitle,
  SimpleHeader,

  // for old version
  Link,
  Title
}



// WEBPACK FOOTER //
// ./src/components/header/index.js